import {
	EVENTS_DATA,
	EVENTS_LOADED,
	EVENTS_ERROR,
	EVENTS_FILTERS_DATA,
	EVENTS_FILTERS_LOADED,
	EVENTS_FILTERS_ERROR,
	EVENTS_STATUSES_DATA,
	EVENTS_STATUSES_LOADED,
	EVENTS_STATUSES_ERROR
} from "../reducers/eventsReducer";

export const getEventsData = (url, params) => dispatch => {

	dispatch({ type: EVENTS_LOADED, payload: false });

	const filtersToURLparams = (filters) => {
		let URLparams = "";
		for (let i = 0, keys = Object.keys(filters); i < keys.length; ++i) {
			if (Array.isArray(filters[keys[i]]))
				for (const arg of filters[keys[i]]) URLparams += `&${keys[i]}=${arg}`;
			else URLparams += `&${keys[i]}=${filters[keys[i]]}`;
		}
		return URLparams;
	}

	fetch(`${url}?${filtersToURLparams(params)}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: EVENTS_DATA, payload: data._data });
				dispatch({ type: EVENTS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: EVENTS_ERROR, payload: err.message });
		});
}

export const getEventsFiltersData = (url, params) => (dispatch) => {
	fetch(`${url}?${new URLSearchParams(params).toString()}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: EVENTS_FILTERS_DATA, payload: data._data.filters });
				dispatch({ type: EVENTS_FILTERS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: EVENTS_FILTERS_ERROR, payload: err.message });
		});
}

export const getEventsStatusesData = (url) => (dispatch) => {
	fetch(url)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: EVENTS_STATUSES_DATA, payload: data._data.event_statuses });
				dispatch({ type: EVENTS_STATUSES_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: EVENTS_STATUSES_ERROR, payload: err.message });
		});
}